import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase-config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/styles/AdminShared.css";

const AdminLaunch = () => {
  const { projectId } = useParams();
  const [videoTutorialLink, setVideoTutorialLink] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [finalPaymentLink, setFinalPaymentLink] = useState("");
  const [checklist, setChecklist] = useState([
    { id: 1, label: "Verify site is reachable at custom domain", completed: false },
    { id: 2, label: "Conduct final walkthrough of the website", completed: false },
    { id: 3, label: "Test all links and navigation on the site", completed: false },
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        if (!projectId) throw new Error("Project ID is not provided in the URL.");
        const projectDocRef = doc(db, "projects", projectId);
        const projectDocSnap = await getDoc(projectDocRef);
        if (!projectDocSnap.exists()) throw new Error("Project document not found.");
        const data = projectDocSnap.data();
        setVideoTutorialLink(data.videoTutorialLink || "");
        setWebsiteURL(data.websiteURL || "");
        setFinalPaymentLink(data.finalPaymentLink || "");
        setLoading(false);
      } catch (error) {
        toast.error("Failed to load project data. Please try again.");
        setLoading(false);
      }
    };
    fetchProjectData();
  }, [projectId]);

  const handleSaveLinks = async () => {
    try {
      if (!projectId) throw new Error("Project ID is not available.");
      await updateDoc(doc(db, "projects", projectId), { videoTutorialLink, websiteURL, finalPaymentLink });
      toast.success("Links updated successfully!");
    } catch (error) {
      toast.error("Failed to update links. Please try again.");
    }
  };

  const toggleChecklistItem = (id) => {
    setChecklist(prev => prev.map(item => item.id === id ? { ...item, completed: !item.completed } : item));
  };

  const isLaunchReady = checklist.every(item => item.completed);

  if (loading) return <div className="ap-loading"><p>Loading launch data...</p></div>;

  return (
    <div className="ap-page ap-page--narrow">
      <ToastContainer />
      <div className="ap-page-header">
        <a href={`/admin/project/${projectId}`} className="ap-back">← Back to project</a>
        <p className="ap-eyebrow">Admin — Launch</p>
        <h1 className="ap-title">Set Launch Links</h1>
        <p className="ap-subtitle">Set or update the website URL, video tutorial, and final payment link before launch.</p>
      </div>

      <div className="ap-section" style={{ marginBottom: '20px' }}>
        <div className="ap-section-header">
          <h2 className="ap-section-title">Launch Links</h2>
        </div>
        <div className="ap-section-body">
          <div className="ap-form-group">
            <label>Website URL</label>
            <input type="text" value={websiteURL} onChange={e => setWebsiteURL(e.target.value)} placeholder="https://client-domain.com" />
          </div>
          <div className="ap-form-group">
            <label>Video Tutorial Link</label>
            <input type="text" value={videoTutorialLink} onChange={e => setVideoTutorialLink(e.target.value)} placeholder="https://youtube.com/..." />
          </div>
          <div className="ap-form-group">
            <label>Final Payment Link</label>
            <input type="text" value={finalPaymentLink} onChange={e => setFinalPaymentLink(e.target.value)} placeholder="https://stripe.com/..." />
          </div>
          <div className="ap-btn-row">
            <button className="ap-btn-primary" onClick={handleSaveLinks}>Save Links</button>
          </div>
        </div>
      </div>

      <div className="ap-section">
        <div className="ap-section-header">
          <h2 className="ap-section-title">Pre-Launch Checklist</h2>
          {isLaunchReady
            ? <span className="ap-badge ap-badge--active">Ready to Launch</span>
            : <span className="ap-badge ap-badge--pending">Incomplete</span>
          }
        </div>
        <div className="ap-section-body">
          <ul className="ap-checklist">
            {checklist.map(item => (
              <li key={item.id} className={`ap-checklist-item${item.completed ? ' done' : ''}`}>
                <input type="checkbox" checked={item.completed} onChange={() => toggleChecklistItem(item.id)} />
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminLaunch;
